<template>

    <oa-modal :name="name">

        <template slot="description">Case details updated!</template>

        <template slot="footer">
            <div class="ut-text-center">
            <button class="btn btn-green" @click="confirmClicked">
                Close
            </button>
            </div>
        </template>

    </oa-modal>

</template>

<script>
import OaModal from '@/components/Modals/OaModal.vue';

export default {
  name: 'CaseUpdatedModal',
  components: { OaModal },
  data() {
    return {
      name: 'case-updated-modal',
      onconfirm: null,
    };
  },
  methods: {
    closeModal() {
      this.$modal.hide(this.name);
    },
    confirmClicked() {
      this.closeModal();
    },
  },
};
</script>

<style scoped>

</style>
